module.exports = __webpack_public_path__ + "img/house.da26dfc3.svg";